<div class="cwc-sheet">
  <!-- drag handle -->
  <div class="cwc-grip"></div>

  <!-- header -->
  <div class="cwc-header">
    <div class="cwc-header-icon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round">
        <path d="M3 8h11a2.5 2.5 0 1 0-2.5-2.5M3 16h13a2.5 2.5 0 1 1-2.5 2.5M3 12h7a2 2 0 1 0-2-2"/>
      </svg>
    </div>
    <div class="cwc-header-text">
      <div class="cwc-title">Wind models · next 10 days</div>
      <div class="cwc-subtitle">{{ subtitle }}</div>
    </div>
    <button type="button" class="cwc-close" (click)="onClose()" aria-label="Close">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#9FB6CC" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>
    </button>
  </div>

  <div class="cwc-divider"></div>

  <div class="cwc-body">
    <!-- legend -->
    <div class="cwc-legend" *ngIf="series.length">
      <span class="cwc-legend-item" *ngFor="let s of series">
        <span class="cwc-legend-dot" [style.background]="s.color"></span>
        <span class="cwc-legend-label">{{ s.label }}</span>
      </span>
    </div>

    <!-- chart panel -->
    <div class="cwc-chart-card">
      <!-- chart -->
      <div
        #plot
        class="cwc-plot"
        *ngIf="hasChart"
        (pointerdown)="onPointerDown($event)"
        (pointermove)="onPointerMove($event)"
        (pointerup)="onPointerUp($event)"
        (pointercancel)="onPointerUp($event)"
      >
        <canvas #canvas class="cwc-canvas" [style.height.px]="chartHeight"></canvas>
        <div
          class="cwc-tooltip"
          *ngIf="tooltip"
          [style.left.px]="tooltip.left"
          [style.top.px]="tooltip.top"
        >
          <div class="cwc-tooltip-header">{{ tooltip.header }}</div>
          <div class="cwc-tooltip-row" *ngFor="let r of tooltip.rows">
            <span class="cwc-tooltip-dot" [style.background]="r.color"></span>
            <span class="cwc-tooltip-label">{{ r.label }}: {{ r.value }}</span>
          </div>
        </div>
      </div>

      <!-- states -->
      <div class="cwc-state" *ngIf="!hasChart">
        <ng-container *ngIf="loading">
          <span class="cwc-state-text">loading…</span>
        </ng-container>
        <ng-container *ngIf="!loading && error">
          <span class="cwc-state-text">wind warming up</span>
          <button type="button" class="cwc-retry" (click)="onRetry()">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#E6F0FA" stroke-width="2" stroke-linecap="round"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/></svg>
            Retry
          </button>
        </ng-container>
        <ng-container *ngIf="!loading && !error">
          <span class="cwc-state-text">no data</span>
        </ng-container>
      </div>
    </div>
  </div>
</div>
